var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "dl",
    { staticClass: "row" },
    [
      _c("dt", { staticClass: "font-weight-bold col-sm-3" }, [
        _vm._v(_vm._s(_vm.labels.naam))
      ]),
      _vm._v(" "),
      _c("dd", { staticClass: "col-sm-9" }, [
        _vm._v(_vm._s(_vm.personeelslid.naam))
      ]),
      _vm._v(" "),
      _c("dt", { staticClass: "font-weight-bold col-sm-3" }, [
        _vm._v(_vm._s(_vm.labels.voornaam))
      ]),
      _vm._v(" "),
      _c("dd", { staticClass: "col-sm-9" }, [
        _vm._v(_vm._s(_vm.personeelslid.voornaam))
      ]),
      _vm._v(" "),
      _c("dt", { staticClass: "font-weight-bold col-sm-3" }, [
        _vm._v(_vm._s(_vm.labels.voornaam2))
      ]),
      _vm._v(" "),
      _c("dd", { staticClass: "col-sm-9" }, [
        _vm._v(_vm._s(_vm.personeelslid.voornaam2))
      ]),
      _vm._v(" "),
      _c("dt", { staticClass: "font-weight-bold col-sm-3" }, [
        _vm._v(_vm._s(_vm.labels.roepnaam))
      ]),
      _vm._v(" "),
      _c("dd", { staticClass: "col-sm-9" }, [
        _vm._v(_vm._s(_vm.personeelslid.roepnaam))
      ]),
      _vm._v(" "),
      _vm.personeelslid.initialen && !_vm.hiddenFieldsMap.initialen
        ? [
            _c("dt", { staticClass: "font-weight-bold col-sm-3" }, [
              _vm._v(_vm._s(_vm.labels.initialen))
            ]),
            _vm._v(" "),
            _c("dd", { staticClass: "col-sm-9" }, [
              _vm._v(_vm._s(_vm.personeelslid.initialen))
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("dt", { staticClass: "font-weight-bold col-sm-3" }, [
        _vm._v(_vm._s(_vm.labels.geslacht))
      ]),
      _vm._v(" "),
      _c("dd", { staticClass: "col-sm-9" }, [
        _vm._v(_vm._s(_vm.personeelslid.geslacht))
      ]),
      _vm._v(" "),
      _c("dt", { staticClass: "font-weight-bold col-sm-3" }, [
        _vm._v(_vm._s(_vm.labels.geboortedatum))
      ]),
      _vm._v(" "),
      _c("dd", { staticClass: "col-sm-9" }, [
        _vm._v(_vm._s(_vm.personeelslid.geboortedatum))
      ]),
      _vm._v(" "),
      _c("dt", { staticClass: "font-weight-bold col-sm-3" }, [
        _vm._v(_vm._s(_vm.labels.geboorteplaats))
      ]),
      _vm._v(" "),
      _c("dd", { staticClass: "col-sm-9" }, [
        _vm._v(_vm._s(_vm.personeelslid.geboorteplaats))
      ]),
      _vm._v(" "),
      _c("dt", { staticClass: "font-weight-bold col-sm-3" }, [
        _vm._v(_vm._s(_vm.labels.geboorteland))
      ]),
      _vm._v(" "),
      _c("dd", { staticClass: "col-sm-9" }, [
        _vm._v(_vm._s(_vm.personeelslid.geboorteland.land))
      ]),
      _vm._v(" "),
      _c("dt", { staticClass: "font-weight-bold col-sm-3" }, [
        _vm._v(_vm._s(_vm.labels.persMindervalide))
      ]),
      _vm._v(" "),
      _c("dd", { staticClass: "col-sm-9" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.personeelslid.persMindervalide ? "Ja" : "Nee") +
            "\n  "
        )
      ]),
      _vm._v(" "),
      _vm.personeelslid.inszNr
        ? [
            _c("dt", { staticClass: "font-weight-bold col-sm-3" }, [
              _vm._v(_vm._s(_vm.labels.inszNr))
            ]),
            _vm._v(" "),
            _c("dd", { staticClass: "col-sm-9" }, [
              _vm._v(_vm._s(_vm.formatInsz(_vm.personeelslid.inszNr)))
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("dt", { staticClass: "font-weight-bold col-sm-3" }, [
        _vm._v(_vm._s(_vm.labels.stamnummer))
      ]),
      _vm._v(" "),
      _c("dd", { staticClass: "col-sm-9" }, [
        _vm._v(_vm._s(_vm.personeelslid.stamnummer))
      ]),
      _vm._v(" "),
      _vm.personeelslid.contrStamnummer
        ? [
            _c("dt", { staticClass: "font-weight-bold col-sm-3" }, [
              _vm._v(_vm._s(_vm.labels.contrStamnummer))
            ]),
            _vm._v(" "),
            _c("dd", { staticClass: "col-sm-9" }, [
              _vm._v(_vm._s(_vm.personeelslid.contrStamnummer))
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.personeelslid.werknemerscode && !_vm.hiddenFieldsMap.werknemerscode
        ? [
            _c("dt", { staticClass: "font-weight-bold col-sm-3" }, [
              _vm._v(_vm._s(_vm.labels.werknemerscode))
            ]),
            _vm._v(" "),
            _c("dd", { staticClass: "col-sm-9" }, [
              _vm._v(_vm._s(_vm.personeelslid.werknemerscode))
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.personeelslid.natio.length == 1
        ? _c("label", { staticClass: "font-weight-bold col-sm-3" }, [
            _vm._v(_vm._s(_vm.labels.natio.objectName.singular))
          ])
        : _c("label", { staticClass: "font-weight-bold col-sm-3" }, [
            _vm._v(_vm._s(_vm.labels.natio.objectName.plural))
          ]),
      _vm._v(" "),
      _c("dd", { staticClass: "col-sm-9" }, [
        _c(
          "dl",
          { staticClass: "row" },
          [
            _vm._l(_vm.personeelslid.natio, function(natio, index) {
              return [
                _c(
                  "dd",
                  {
                    key: "dd-personeelslid-natio-" + parseInt(index),
                    staticClass: "col-sm-9"
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(natio.nationaliteit) +
                        "\n        "
                    )
                  ]
                )
              ]
            })
          ],
          2
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }